import { createGlobalStyle } from 'styled-components'
import {minCol,maxCol} from "../../function/SizeCol"
import Icons24_32 from "../svg/24/Icons24px-32.svg"
import Icons24_31 from "../svg/24/Icons24px-31.svg"
import Icons24_20 from "../svg/24/Icons24px-20.svg"

import Light from '../fonts/Geologica-Light.woff2';
import Regular from '../fonts/Geologica-Regular.woff2';
import SemiBold from '../fonts/Geologica-SemiBold.woff2';
import ExtraBold from '../fonts/Geologica-ExtraBold.woff2';
import Black from '../fonts/Geologica-Black.woff2';
import React from "react";

const GlobalStyles = createGlobalStyle`
    //Global Fonts  ********************************************
    @font-face {
        font-family: 'Geologica';
        font-style: normal; 
        font-weight: 300; 
        src: url("${Light}") format("woff2");
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        font-optical-sizing: auto;
        font-display: swap;
    }
    @font-face {
        font-family: 'Geologica';
        font-style: normal;
        font-weight: 400;
        src: url("${Regular}") format("woff2");
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        font-optical-sizing: auto;
        font-display: swap;
        
    }
    @font-face {
        font-family: 'Geologica';
        font-style: normal;
        font-weight: 600;
        src: url("${SemiBold}") format("woff2");
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        font-optical-sizing: auto;
        font-display: swap;
    }
    @font-face {
        font-family: 'Geologica';
        font-style: normal;
        font-weight: 800;
        src: url("${ExtraBold}") format("woff2");
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        font-optical-sizing: auto;
        font-display: swap;
    }
 
    @font-face {
        font-family: 'Geologica';
        font-style: normal; 
        font-weight: 900;
        src: url("${Black}") format("woff2");
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        font-optical-sizing: auto;
        font-display: swap;
    }
    
    //Global Cols  ********************************************
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    .container,.container-fluid,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl {
        width:100%;
        padding-right:var(--bs-gutter-x,.75rem);
        padding-left:var(--bs-gutter-x,.75rem);
        margin-right:auto; 
        margin-left:auto
    } 
    @media (min-width:${minCol.sm}) {
        .container,.container-sm {
            //max-width:540px
        } 
    }
    @media (min-width:${minCol.md}) {
        .container,.container-md,.container-sm {
            //max-width:720px
        }
    }
    @media (min-width:${minCol.lg}) {
        .container,.container-lg,.container-md,.container-sm {
            //max-width:960px
        }
    }
    @media (min-width:${minCol.xl}) {
        .container,.container-lg,.container-md,.container-sm,.container-xl {
            //max-width:1140px
        }
    }
    @media (min-width:${minCol.xxl}) {
        .container,.container-lg,.container-md,.container-sm,.container-xl,.container-xxl {
            max-width:1440px
        }
    }
    .row {
        --bs-gutter-x:1.5rem;
        --bs-gutter-y:0;
        display:flex;
        flex-wrap:wrap;
        margin-top:calc(-1 * var(--bs-gutter-y));
        
          margin-right:calc( -1 * var(--bs-gutter-x));
          margin-left:calc( -1 * var(--bs-gutter-x));
          @media(max-width: ${maxCol.md}) {
             margin-right:calc(-.5 * var(--bs-gutter-x));
             margin-left:calc(-.5 * var(--bs-gutter-x)) 
          } 
    }
    .row>* {
        box-sizing:border-box;
        flex-shrink:0;
        width:100%;
        max-width:100%;
        
        padding-right:calc(var(--bs-gutter-x) ); 
        padding-left:calc(var(--bs-gutter-x) );
        @media(max-width: ${maxCol.md}) {
          padding-right:calc(var(--bs-gutter-x) * .5);
          padding-left:calc(var(--bs-gutter-x) * .5);
        }
        margin-top:var(--bs-gutter-y)
    }
    .col{flex:1 0 0}
    .row-cols-auto>*{flex:0 0 auto;width:auto}
    .row-cols-1>*{flex:0 0 auto;width:100%}
    .row-cols-2>*{flex:0 0 auto;width:50%}
    .row-cols-3>*{flex:0 0 auto;width:33.3333333333%}
    .row-cols-4>*{flex:0 0 auto;width:25%}
    .row-cols-5>*{flex:0 0 auto;width:20%}
    .row-cols-6>*{flex:0 0 auto;width:16.6666666667%}
    .col-auto{flex:0 0 auto;width:auto}
    .col-1{flex:0 0 auto;width:8.33333333%}
    .col-2{flex:0 0 auto;width:16.66666667%}
    .col-3{flex:0 0 auto;width:25%}
    .col-4{flex:0 0 auto;width:33.33333333%}
    .col-5{flex:0 0 auto;width:41.66666667%}
    .col-6{flex:0 0 auto;width:50%}
    .col-7{flex:0 0 auto;width:58.33333333%}
    .col-8{flex:0 0 auto;width:66.66666667%}
    .col-9{flex:0 0 auto;width:75%}
    .col-10{flex:0 0 auto;width:83.33333333%}
    .col-11{flex:0 0 auto;width:91.66666667%}
    .col-12{flex:0 0 auto;width:100%}
    .offset-1{margin-left:8.33333333%}
    .offset-2{margin-left:16.66666667%}
    .offset-3{margin-left:25%}
    .offset-4{margin-left:33.33333333%}
    .offset-5{margin-left:41.66666667%}
    .offset-6{margin-left:50%}
    .offset-7{margin-left:58.33333333%}
    .offset-8{margin-left:66.66666667%}
    .offset-9{margin-left:75%}
    .offset-10{margin-left:83.33333333%} 
    .offset-11{margin-left:91.66666667%}
    @media (min-width:${minCol.sm}) { 
        .col-sm{flex:1 0 0}
        .row-cols-sm-auto>*{flex:0 0 auto;width:auto}
        .row-cols-sm-1>*{flex:0 0 auto;width:100%}
        .row-cols-sm-2>*{flex:0 0 auto;width:50%}
        .row-cols-sm-3>*{flex:0 0 auto;width:33.3333333333%}
        .row-cols-sm-4>*{flex:0 0 auto;width:25%}
        .row-cols-sm-5>*{flex:0 0 auto;width:20%}
        .row-cols-sm-6>*{flex:0 0 auto;width:16.6666666667%}
        .col-sm-auto{flex:0 0 auto;width:auto}
        .col-sm-1{flex:0 0 auto;width:8.33333333%}
        .col-sm-2{flex:0 0 auto;width:16.66666667%}
        .col-sm-3{flex:0 0 auto;width:25%}
        .col-sm-4{flex:0 0 auto;width:33.33333333%}
        .col-sm-5{flex:0 0 auto;width:41.66666667%}
        .col-sm-6{flex:0 0 auto;width:50%}
        .col-sm-7{flex:0 0 auto;width:58.33333333%}
        .col-sm-8{flex:0 0 auto;width:66.66666667%}
        .col-sm-9{flex:0 0 auto;width:75%}
        .col-sm-10{flex:0 0 auto;width:83.33333333%}
        .col-sm-11{flex:0 0 auto;width:91.66666667%}
        .col-sm-12{flex:0 0 auto;width:100%}
        .offset-sm-0{margin-left:0}
        .offset-sm-1{margin-left:8.33333333%}
        .offset-sm-2{margin-left:16.66666667%}
        .offset-sm-3{margin-left:25%}
        .offset-sm-4{margin-left:33.33333333%}
        .offset-sm-5{margin-left:41.66666667%}
        .offset-sm-6{margin-left:50%}
        .offset-sm-7{margin-left:58.33333333%}
        .offset-sm-8{margin-left:66.66666667%}
        .offset-sm-9{margin-left:75%}
        .offset-sm-10{margin-left:83.33333333%}
        .offset-sm-11{margin-left:91.66666667%}
    }
    @media (min-width:${minCol.md}) {
        .col-md{flex:1 0 0}
        .row-cols-md-auto>*{flex:0 0 auto;width:auto}
        .row-cols-md-1>*{flex:0 0 auto;width:100%}
        .row-cols-md-2>*{flex:0 0 auto;width:50%}
        .row-cols-md-3>*{flex:0 0 auto;width:33.3333333333%}
        .row-cols-md-4>*{flex:0 0 auto;width:25%}
        .row-cols-md-5>*{flex:0 0 auto;width:20%}
        .row-cols-md-6>*{flex:0 0 auto;width:16.6666666667%}
        .col-md-auto{flex:0 0 auto;width:auto}
        .col-md-1{flex:0 0 auto;width:8.33333333%}
        .col-md-2{flex:0 0 auto;width:16.66666667%}
        .col-md-3{flex:0 0 auto;width:25%}
        .col-md-4{flex:0 0 auto;width:33.33333333%}
        .col-md-5{flex:0 0 auto;width:41.66666667%}
        .col-md-6{flex:0 0 auto;width:50%}
        .col-md-7{flex:0 0 auto;width:58.33333333%}
        .col-md-8{flex:0 0 auto;width:66.66666667%}
        .col-md-9{flex:0 0 auto;width:75%}
        .col-md-10{flex:0 0 auto;width:83.33333333%}
        .col-md-11{flex:0 0 auto;width:91.66666667%}
        .col-md-12{flex:0 0 auto;width:100%}
        .offset-md-0{margin-left:0}
        .offset-md-1{margin-left:8.33333333%}
        .offset-md-2{margin-left:16.66666667%}
        .offset-md-3{margin-left:25%}
        .offset-md-4{margin-left:33.33333333%}
        .offset-md-5{margin-left:41.66666667%}
        .offset-md-6{margin-left:50%}
        .offset-md-7{margin-left:58.33333333%}
        .offset-md-8{margin-left:66.66666667%}
        .offset-md-9{margin-left:75%}
        .offset-md-10{margin-left:83.33333333%}
        .offset-md-11{margin-left:91.66666667%}
    }
    @media (min-width:${minCol.lg}) {
        .col-lg{flex:1 0 0}
        .row-cols-lg-auto>*{flex:0 0 auto;width:auto}
        .row-cols-lg-1>*{flex:0 0 auto;width:100%}
        .row-cols-lg-2>*{flex:0 0 auto;width:50%}
        .row-cols-lg-3>*{flex:0 0 auto;width:33.3333333333%}
        .row-cols-lg-4>*{flex:0 0 auto;width:25%}
        .row-cols-lg-5>*{flex:0 0 auto;width:20%}
        .row-cols-lg-6>*{flex:0 0 auto;width:16.6666666667%}
        .col-lg-auto{flex:0 0 auto;width:auto}
        .col-lg-1{flex:0 0 auto;width:8.33333333%}
        .col-lg-2{flex:0 0 auto;width:16.66666667%}
        .col-lg-3{flex:0 0 auto;width:25%}
        .col-lg-4{flex:0 0 auto;width:33.33333333%}
        .col-lg-5{flex:0 0 auto;width:41.66666667%}
        .col-lg-6{flex:0 0 auto;width:50%}
        .col-lg-7{flex:0 0 auto;width:58.33333333%}
        .col-lg-8{flex:0 0 auto;width:66.66666667%}
        .col-lg-9{flex:0 0 auto;width:75%}
        .col-lg-10{flex:0 0 auto;width:83.33333333%}
        .col-lg-11{flex:0 0 auto;width:91.66666667%}
        .col-lg-12{flex:0 0 auto;width:100%}
        .offset-lg-0{margin-left:0}
        .offset-lg-1{margin-left:8.33333333%}
        .offset-lg-2{margin-left:16.66666667%}
        .offset-lg-3{margin-left:25%}
        .offset-lg-4{margin-left:33.33333333%}
        .offset-lg-5{margin-left:41.66666667%}
        .offset-lg-6{margin-left:50%}
        .offset-lg-7{margin-left:58.33333333%}
        .offset-lg-8{margin-left:66.66666667%}
        .offset-lg-9{margin-left:75%}
        .offset-lg-10{margin-left:83.33333333%}
        .offset-lg-11{margin-left:91.66666667%}
    }
    
    @media (min-width:${minCol.xl}) {
        .col-xl{flex:1 0 0}
        .row-cols-xl-auto>*{flex:0 0 auto;width:auto}
        .row-cols-xl-1>*{flex:0 0 auto;width:100%}
        .row-cols-xl-2>*{flex:0 0 auto;width:50%}
        .row-cols-xl-3>*{flex:0 0 auto;width:33.3333333333%}
        .row-cols-xl-4>*{flex:0 0 auto;width:25%}
        .row-cols-xl-5>*{flex:0 0 auto;width:20%}
        .row-cols-xl-6>*{flex:0 0 auto;width:16.6666666667%}
        .col-xl-auto{flex:0 0 auto;width:auto}
        .col-xl-1{flex:0 0 auto;width:8.33333333%}
        .col-xl-2{flex:0 0 auto;width:16.66666667%}
        .col-xl-3{flex:0 0 auto;width:25%}
        .col-xl-4{flex:0 0 auto;width:33.33333333%}
        .col-xl-5{flex:0 0 auto;width:41.66666667%}
        .col-xl-6{flex:0 0 auto;width:50%}
        .col-xl-7{flex:0 0 auto;width:58.33333333%}
        .col-xl-8{flex:0 0 auto;width:66.66666667%}
        .col-xl-9{flex:0 0 auto;width:75%}
        .col-xl-10{flex:0 0 auto;width:83.33333333%}
        .col-xl-11{flex:0 0 auto;width:91.66666667%}
        .col-xl-12{flex:0 0 auto;width:100%}
        .offset-xl-0{margin-left:0}
        .offset-xl-1{margin-left:8.33333333%}
        .offset-xl-2{margin-left:16.66666667%}
        .offset-xl-3{margin-left:25%}
        .offset-xl-4{margin-left:33.33333333%}
        .offset-xl-5{margin-left:41.66666667%}
        .offset-xl-6{margin-left:50%}
        .offset-xl-7{margin-left:58.33333333%}
        .offset-xl-8{margin-left:66.66666667%}
        .offset-xl-9{margin-left:75%}
        .offset-xl-10{margin-left:83.33333333%}
        .offset-xl-11{margin-left:91.66666667%}
    }
    
    @media (min-width:${minCol.xxl}) {
        .col-xxl{flex:1 0 0}
        .row-cols-xxl-auto>*{flex:0 0 auto;width:auto}
        .row-cols-xxl-1>*{flex:0 0 auto;width:100%}
        .row-cols-xxl-2>*{flex:0 0 auto;width:50%}
        .row-cols-xxl-3>*{flex:0 0 auto;width:33.3333333333%}
        .row-cols-xxl-4>*{flex:0 0 auto;width:25%}
        .row-cols-xxl-5>*{flex:0 0 auto;width:20%}
        .row-cols-xxl-6>*{flex:0 0 auto;width:16.6666666667%}
        .col-xxl-auto{flex:0 0 auto;width:auto}
        .col-xxl-1{flex:0 0 auto;width:8.33333333%}
        .col-xxl-2{flex:0 0 auto;width:16.66666667%}
        .col-xxl-3{flex:0 0 auto;width:25%}
        .col-xxl-4{flex:0 0 auto;width:33.33333333%}
        .col-xxl-5{flex:0 0 auto;width:41.66666667%}
        .col-xxl-6{flex:0 0 auto;width:50%}
        .col-xxl-7{flex:0 0 auto;width:58.33333333%}
        .col-xxl-8{flex:0 0 auto;width:66.66666667%}
        .col-xxl-9{flex:0 0 auto;width:75%}
        .col-xxl-10{flex:0 0 auto;width:83.33333333%}
        .col-xxl-11{flex:0 0 auto;width:91.66666667%}
        .col-xxl-12{flex:0 0 auto;width:100%}
        .offset-xxl-0{margin-left:0}
        .offset-xxl-1{margin-left:8.33333333%}
        .offset-xxl-2{margin-left:16.66666667%}
        .offset-xxl-3{margin-left:25%}
        .offset-xxl-4{margin-left:33.33333333%}
        .offset-xxl-5{margin-left:41.66666667%}
        .offset-xxl-6{margin-left:50%}
        .offset-xxl-7{margin-left:58.33333333%}
        .offset-xxl-8{margin-left:66.66666667%}
        .offset-xxl-9{margin-left:75%}
        .offset-xxl-10{margin-left:83.33333333%}
        .offset-xxl-11{margin-left:91.66666667%}
    }
    
    .d-inline{display:inline}
    .d-inline-block{display:inline-block}
    .d-block{display:block}
    .d-flex{display:flex}
    .d-inline-flex{display:inline-flex}
    .d-none{display:none}
    .flex-fill{flex:1 1 auto}
    .flex-row{flex-direction:row}
    .flex-column{flex-direction:column}
    .flex-row-reverse{flex-direction:row-reverse}
    .flex-column-reverse{flex-direction:column-reverse}
    .flex-grow-0{flex-grow:0}
    .flex-grow-1{flex-grow:1}
    .flex-shrink-0{flex-shrink:0}
    .flex-shrink-1{flex-shrink:1}
    .flex-wrap{flex-wrap:wrap}
    .flex-nowrap{flex-wrap:nowrap} 
    .flex-wrap-reverse{flex-wrap:wrap-reverse}
    .justify-content-start{justify-content:flex-start}
    .justify-content-end{justify-content:flex-end}
    .justify-content-center{justify-content:center}
    .justify-content-between{justify-content:space-between} 
    .justify-content-around{justify-content:space-around}
    .justify-content-evenly{justify-content:space-evenly}
    .align-items-start{align-items:flex-start}
    .align-items-end{align-items:flex-end}
    .align-items-center{align-items:center}
    .align-items-baseline{align-items:baseline}
    .align-items-stretch{align-items:stretch}
    .align-content-start{align-content:flex-start}
    .align-content-end{align-content:flex-end}
    .align-content-center{align-content:center}
    .align-content-between{align-content:space-between}
    .align-content-around{align-content:space-around}
    .align-content-stretch{align-content:stretch}
    .align-self-auto{align-self:auto}
    .align-self-start{align-self:flex-start}
    .align-self-end{align-self:flex-end}
    .align-self-center{align-self:center}
    .align-self-baseline{align-self:baseline}
    .align-self-stretch{align-self:stretch}
    .order-first{order:-1}
    .order-0{order:0}
    .order-1{order:1}
    .order-2{order:2}
    .order-3{order:3}
    .order-4{order:4}
    .order-5{order:5}
    .order-last{order:6} 
    
    @media (min-width:${minCol.sm}) {
        .d-sm-inline{display:inline}
        .d-sm-inline-block{display:inline-block}
        .d-sm-block{display:block}
        .d-sm-flex{display:flex}
        .d-sm-inline-flex{display:inline-flex}
        .d-sm-none{display:none}
        .flex-sm-fill{flex:1 1 auto}
        .flex-sm-row{flex-direction:row}
        .flex-sm-column{flex-direction:column}
        .flex-sm-row-reverse{flex-direction:row-reverse}
        .flex-sm-column-reverse{flex-direction:column-reverse}
        .flex-sm-grow-0{flex-grow:0}
        .flex-sm-grow-1{flex-grow:1}
        .flex-sm-shrink-0{flex-shrink:0}
        .flex-sm-shrink-1{flex-shrink:1}
        .flex-sm-wrap{flex-wrap:wrap}
        .flex-sm-nowrap{flex-wrap:nowrap}
        .flex-sm-wrap-reverse{flex-wrap:wrap-reverse}
        .justify-content-sm-start{justify-content:flex-start}
        .justify-content-sm-end{justify-content:flex-end}
        .justify-content-sm-center{justify-content:center}
        .justify-content-sm-between{justify-content:space-between}
        .justify-content-sm-around{justify-content:space-around}
        .justify-content-sm-evenly{justify-content:space-evenly}
        .align-items-sm-start{align-items:flex-start}
        .align-items-sm-end{align-items:flex-end}
        .align-items-sm-center{align-items:center}
        .align-items-sm-baseline{align-items:baseline}
        .align-items-sm-stretch{align-items:stretch}
        .align-content-sm-start{align-content:flex-start}
        .align-content-sm-end{align-content:flex-end}
        .align-content-sm-center{align-content:center}
        .align-content-sm-between{align-content:space-between}
        .align-content-sm-around{align-content:space-around}
        .align-content-sm-stretch{align-content:stretch}
        .align-self-sm-auto{align-self:auto}
        .align-self-sm-start{align-self:flex-start}
        .align-self-sm-end{align-self:flex-end}
        .align-self-sm-center{align-self:center}
        .align-self-sm-baseline{align-self:baseline}
        .align-self-sm-stretch{align-self:stretch}
        .order-sm-first{order:-1}
        .order-sm-0{order:0}
        .order-sm-1{order:1}
        .order-sm-2{order:2}
        .order-sm-3{order:3}
        .order-sm-4{order:4}
        .order-sm-5{order:5}
        .order-sm-last{order:6}
    }
    @media (min-width:${minCol.md}) {
        .d-md-inline{display:inline}
        .d-md-inline-block{display:inline-block}
        .d-md-block{display:block}
        .d-md-flex{display:flex}
        .d-md-inline-flex{display:inline-flex}
        .d-md-none{display:none}
        .flex-md-fill{flex:1 1 auto}
        .flex-md-row{flex-direction:row}
        .flex-md-column{flex-direction:column}
        .flex-md-row-reverse{flex-direction:row-reverse}
        .flex-md-column-reverse{flex-direction:column-reverse}
        .flex-md-grow-0{flex-grow:0}
        .flex-md-grow-1{flex-grow:1}
        .flex-md-shrink-0{flex-shrink:0}
        .flex-md-shrink-1{flex-shrink:1}
        .flex-md-wrap{flex-wrap:wrap}
        .flex-md-nowrap{flex-wrap:nowrap}
        .flex-md-wrap-reverse{flex-wrap:wrap-reverse}
        .justify-content-md-start{justify-content:flex-start}
        .justify-content-md-end{justify-content:flex-end}
        .justify-content-md-center{justify-content:center}
        .justify-content-md-between{justify-content:space-between}
        .justify-content-md-around{justify-content:space-around}
        .justify-content-md-evenly{justify-content:space-evenly}
        .align-items-md-start{align-items:flex-start}
        .align-items-md-end{align-items:flex-end}
        .align-items-md-center{align-items:center}
        .align-items-md-baseline{align-items:baseline}
        .align-items-md-stretch{align-items:stretch}
        .align-content-md-start{align-content:flex-start}
        .align-content-md-end{align-content:flex-end}
        .align-content-md-center{align-content:center}
        .align-content-md-between{align-content:space-between}
        .align-content-md-around{align-content:space-around}
        .align-content-md-stretch{align-content:stretch}
        .align-self-md-auto{align-self:auto}
        .align-self-md-start{align-self:flex-start}
        .align-self-md-end{align-self:flex-end}
        .align-self-md-center{align-self:center}
        .align-self-md-baseline{align-self:baseline}
        .align-self-md-stretch{align-self:stretch}
        .order-md-first{order:-1}
        .order-md-0{order:0}
        .order-md-1{order:1}
        .order-md-2{order:2}
        .order-md-3{order:3}
        .order-md-4{order:4}
        .order-md-5{order:5}
        .order-md-last{order:6}
    }
    @media (min-width:${minCol.lg}) {
        .d-lg-inline{display:inline}
        .d-lg-inline-block{display:inline-block}
        .d-lg-block{display:block}
        .d-lg-flex{display:flex}
        .d-lg-inline-flex{display:inline-flex}
        .d-lg-none{display:none}
        .flex-lg-fill{flex:1 1 auto}
        .flex-lg-row{flex-direction:row}
        .flex-lg-column{flex-direction:column}
        .flex-lg-row-reverse{flex-direction:row-reverse}
        .flex-lg-column-reverse{flex-direction:column-reverse}
        .flex-lg-grow-0{flex-grow:0}
        .flex-lg-grow-1{flex-grow:1}
        .flex-lg-shrink-0{flex-shrink:0}
        .flex-lg-shrink-1{flex-shrink:1}
        .flex-lg-wrap{flex-wrap:wrap}
        .flex-lg-nowrap{flex-wrap:nowrap}
        .flex-lg-wrap-reverse{flex-wrap:wrap-reverse}
        .justify-content-lg-start{justify-content:flex-start}
        .justify-content-lg-end{justify-content:flex-end}
        .justify-content-lg-center{justify-content:center}
        .justify-content-lg-between{justify-content:space-between}
        .justify-content-lg-around{justify-content:space-around}
        .justify-content-lg-evenly{justify-content:space-evenly}
        .align-items-lg-start{align-items:flex-start}
        .align-items-lg-end{align-items:flex-end}
        .align-items-lg-center{align-items:center}
        .align-items-lg-baseline{align-items:baseline}
        .align-items-lg-stretch{align-items:stretch}
        .align-content-lg-start{align-content:flex-start}
        .align-content-lg-end{align-content:flex-end}
        .align-content-lg-center{align-content:center}
        .align-content-lg-between{align-content:space-between}
        .align-content-lg-around{align-content:space-around}
        .align-content-lg-stretch{align-content:stretch}
        .align-self-lg-auto{align-self:auto}
        .align-self-lg-start{align-self:flex-start}
        .align-self-lg-end{align-self:flex-end}
        .align-self-lg-center{align-self:center}
        .align-self-lg-baseline{align-self:baseline}
        .align-self-lg-stretch{align-self:stretch}
        .order-lg-first{order:-1}
        .order-lg-0{order:0}
        .order-lg-1{order:1}
        .order-lg-2{order:2}
        .order-lg-3{order:3}
        .order-lg-4{order:4}
        .order-lg-5{order:5}
        .order-lg-last{order:6}
    }
    @media (min-width:${minCol.xl}) {
        .d-xl-inline{display:inline}
        .d-xl-inline-block{display:inline-block}
        .d-xl-block{display:block}
        .d-xl-flex{display:flex}
        .d-xl-inline-flex{display:inline-flex}
        .d-xl-none{display:none}
        .flex-xl-fill{flex:1 1 auto}
        .flex-xl-row{flex-direction:row}
        .flex-xl-column{flex-direction:column}
        .flex-xl-row-reverse{flex-direction:row-reverse}
        .flex-xl-column-reverse{flex-direction:column-reverse}
        .flex-xl-grow-0{flex-grow:0}
        .flex-xl-grow-1{flex-grow:1}
        .flex-xl-shrink-0{flex-shrink:0}
        .flex-xl-shrink-1{flex-shrink:1}
        .flex-xl-wrap{flex-wrap:wrap}
        .flex-xl-nowrap{flex-wrap:nowrap}
        .flex-xl-wrap-reverse{flex-wrap:wrap-reverse}
        .justify-content-xl-start{justify-content:flex-start}
        .justify-content-xl-end{justify-content:flex-end}
        .justify-content-xl-center{justify-content:center}
        .justify-content-xl-between{justify-content:space-between}
        .justify-content-xl-around{justify-content:space-around}
        .justify-content-xl-evenly{justify-content:space-evenly}
        .align-items-xl-start{align-items:flex-start}
        .align-items-xl-end{align-items:flex-end}
        .align-items-xl-center{align-items:center}
        .align-items-xl-baseline{align-items:baseline}
        .align-items-xl-stretch{align-items:stretch}
        .align-content-xl-start{align-content:flex-start}
        .align-content-xl-end{align-content:flex-end}
        .align-content-xl-center{align-content:center}
        .align-content-xl-between{align-content:space-between}
        .align-content-xl-around{align-content:space-around}
        .align-content-xl-stretch{align-content:stretch}
        .align-self-xl-auto{align-self:auto}
        .align-self-xl-start{align-self:flex-start}
        .align-self-xl-end{align-self:flex-end}
        .align-self-xl-center{align-self:center}
        .align-self-xl-baseline{align-self:baseline}
        .align-self-xl-stretch{align-self:stretch}
        .order-xl-first{order:-1}
        .order-xl-0{order:0}
        .order-xl-1{order:1}
        .order-xl-2{order:2}
        .order-xl-3{order:3}
        .order-xl-4{order:4}
        .order-xl-5{order:5}
        .order-xl-last{order:6}
    }
    @media (min-width:${minCol.xxl}) {
        .d-xxl-inline{display:inline}
        .d-xxl-inline-block{display:inline-block}
        .d-xxl-block{display:block}
        .d-xxl-flex{display:flex}
        .d-xxl-inline-flex{display:inline-flex}
        .d-xxl-none{display:none}
        .flex-xxl-fill{flex:1 1 auto}
        .flex-xxl-row{flex-direction:row}
        .flex-xxl-column{flex-direction:column}
        .flex-xxl-row-reverse{flex-direction:row-reverse}
        .flex-xxl-column-reverse{flex-direction:column-reverse}
        .flex-xxl-grow-0{flex-grow:0}
        .flex-xxl-grow-1{flex-grow:1}
        .flex-xxl-shrink-0{flex-shrink:0}
        .flex-xxl-shrink-1{flex-shrink:1}
        .flex-xxl-wrap{flex-wrap:wrap}
        .flex-xxl-nowrap{flex-wrap:nowrap}
        .flex-xxl-wrap-reverse{flex-wrap:wrap-reverse}
        .justify-content-xxl-start{justify-content:flex-start}
        .justify-content-xxl-end{justify-content:flex-end}
        .justify-content-xxl-center{justify-content:center}
        .justify-content-xxl-between{justify-content:space-between}
        .justify-content-xxl-around{justify-content:space-around}
        .justify-content-xxl-evenly{justify-content:space-evenly}
        .align-items-xxl-start{align-items:flex-start}
        .align-items-xxl-end{align-items:flex-end}
        .align-items-xxl-center{align-items:center}
        .align-items-xxl-baseline{align-items:baseline}
        .align-items-xxl-stretch{align-items:stretch}
        .align-content-xxl-start{align-content:flex-start}
        .align-content-xxl-end{align-content:flex-end}
        .align-content-xxl-center{align-content:center}
        .align-content-xxl-between{align-content:space-between}
        .align-content-xxl-around{align-content:space-around}
        .align-content-xxl-stretch{align-content:stretch}
        .align-self-xxl-auto{align-self:auto}
        .align-self-xxl-start{align-self:flex-start}
        .align-self-xxl-end{align-self:flex-end}
        .align-self-xxl-center{align-self:center}
        .align-self-xxl-baseline{align-self:baseline}
        .align-self-xxl-stretch{align-self:stretch}
        .order-xxl-first{order:-1}
        .order-xxl-0{order:0}
        .order-xxl-1{order:1}
        .order-xxl-2{order:2}
        .order-xxl-3{order:3}
        .order-xxl-4{order:4}
        .order-xxl-5{order:5}
        .order-xxl-last{order:6}
    }
    
    // global style ***************************************
    
    :root {
        --dark: #020404; // MF Dark
        --gray: #363738; // MF Gray
        --gray_op4: #171818; // MF Gray
        --lgray: #828284; // MF Light Gray
        --slgray: #DFDED7; // MF Super Light Gray
        --paper: #F2F1E8; // MF Paper
        --red : #E32839; //MF Red
        --green: #00D8A9; // MF Green
        --blue: #00A0E2; // MF Blue
        --yellow: #FFA400; // MF Yellow

        // Тонкі декоративні розділювачі (border-ver/border-hor тощо).
        // Свідомо ОКРЕМО від --gray: --gray в темній темі навмисно світлий
        // (потрібен для читабельного тексту), але той самий світлий відтінок
        // на 2px лінії-розділювачі виглядає занадто яскраво/ріже очі.
        --divider: #363738;

        // "Chrome" — завжди темні брендові елементи (футер, оверлей меню,
        // "чорні" варіанти кнопок/інпутів). На відміну від --dark/--paper
        // вище, ці НЕ перевизначаються в [data-theme="dark"] — вони мають
        // лишатись незмінними в обох темах, бо це елементи інтерфейсу
        // (структура), а не контент, що адаптується до теми читача.
        --chrome-dark: #020404;
        --chrome-light: #F2F1E8;
    }

    // Темна тема (перемикається атрибутом data-theme на <html>, див. ThemeContext).
    // Кожна змінна зберігає свою РОЛЬ (--paper лишається "фон/поверхня",
    // --dark/--gray лишаються "чорнило/текст") — міняються лише самі значення,
    // тому весь каскад var(--...) підхоплює тему без правок компонентів.
    [data-theme="dark"] {
        --dark: #F2F1E8;
        --gray: #E8E7DE;
        --gray_op4: #C9C8BF;
        --lgray: #9C9C9E;
        --slgray: #2A2A26;
        --paper: #14151A;
        --divider: #3A3B3A;
    }


    .ovh {
        overflow: hidden;
        

        @media (min-width: ${minCol.lg}) {
            //padding-right: 0.4rem;
            .WrapHeaderScroll {
                header {
                    //padding-right: 2px;
                }
            }
            //padding-right: 4px; 
            //&:after {
            //    content: '';
            //    width: 4px;
            //    background-color: var(--slgray);
            //    display: block;
            //    position: absolute;
            //    top: 0;
            //    bottom: -5000px;
            //    right: 0;
            //    z-index: 200;
            //}
        }
    }
    .ovh-pop {
        overflow: hidden;
    }
    
    img {   
        max-width: 100%;
    }
 
 
    html {
        //scroll-behavior: smooth;
    } 
    
    body::-webkit-scrollbar, html::-webkit-scrollbar, .wrapPop::-webkit-scrollbar  {
        width: 0;
        height: 0;  
    }
    /* width */
    ::-webkit-scrollbar {
      width: 0.4rem;
      height: 0.4rem;
    }
    // #86644B
    /* Track */
    ::-webkit-scrollbar-track {
      background-color: var(--slgray);  
    } 
     
    /* Handle */ 
    ::-webkit-scrollbar-thumb {
        background: var(--blue);
        //background: var(--lgray);
    }
    
    html, body {
        margin: 0;
        padding: 0;
    }

    body, .wrapScroll {
        scroll-behavior: smooth;
    }
    
    
    * {
      outline: none;
    }
    
    strong {
       font-weight: 800;
    }
    
    html {
        //font-size: 50%;
        --bs-gutter-x: 2rem;
        font-size: 50%;
        @media (min-width: ${minCol.sm} ) {
            font-size: 62.5%;
        }
        
        @media (min-width: ${minCol.md} ) {
            
        }
        
        @media (min-width: ${minCol.lg} ) {
    
        }
        
        @media (min-width: ${minCol.xl}) {
            
        }
         
        @media (min-width: ${minCol.xxl}) {
            
        }
    } 
    body {
        font-family: Geologica;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: 1.25;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
        color: var(--gray);
        background-color: var(--paper);
    }
    .main {
        & > *.wrap-product:last-child {
            margin-bottom: 0;
        }
        & > .BlockBannerSlider:first-of-type {
            margin-top: -0.2rem; 
        }
    }
    .body.colorRevers  {
        // Навмисно завжди-темний блок (404/maintenance) — побудований на
        // --chrome-* токенах, які НЕ інвертуються з темою читача, щоб цей
        // вигляд лишався незмінним і в світлій, і в темній темі.
        .main {
            color: var(--chrome-light);
            a {
                color: var(--chrome-light);
            }
        }

        header {
            color: var(--chrome-light);
            a {
                color: var(--chrome-light);
            }
            .btn {
                background-color: rgba(0,0,0,0);
                .iconBG:before {
                    filter: none;
                }
            }
            .btn.btn1 {
                background-color: rgba(0,0,0,0);
                .iconBG:before {
                    filter: brightness(0) invert(1);
                }
            }
        }

        .wrapMenu.style-1 {
            .has-child>a:before {
                border-color: var(--chrome-light);
            }
            .subMenu {
                &:before, &:after {
                    background-color: var(--chrome-dark);
                }
                &:before {
                    border-color: var(--chrome-light);
                }
            }
        }



        background-color: var(--chrome-dark);
        header, header:after {
            background-color: var(--chrome-dark);
        }

        .border-hor:before, .border-hor:after, .border-ver:before, .border-ver:after {
            background-color: var(--chrome-light);
        }
        .row-section>* {
            border-color: var(--chrome-light);
        }
        header {
            .header {
                border-left: none;
                border-right: none;
            }
            &:before {
                display: none;
            }
        }
        .wrapPop {
            .row-section>* {
                border-color: var(--chrome-dark);
            }
            .border-hor:before, .border-hor:after, .border-ver:before, .border-ver:after {
                background-color: var(--chrome-dark);
            }
        }
    }
    .template-page404 {
        background: var(--chrome-dark);

        .container, .main {
            height: 100%;
        }
        .wrapMain {
            display: flex;
            flex-direction: column;
        }
        .wrapMain {
            height: 100vh;
        }
        .footer-1 {
            background: var(--chrome-dark);
            display: none;

        }
        .WrapFooterItem {
            &:after {
                //border-color: #fff !important;
                //display: none;
            }
        }
        .main {
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 1.8rem;
            &:after {
                content: '';
                display: block;
                position: absolute;
                left: -2000px;
                right: -2000px;
                background-color: var(--paper);
                height: 0.2rem;
                bottom: 1.8rem;
                top: auto;
            }
        }
    }    
     
    .wrapContainer {
        max-width: 90rem;
        margin-left: auto;
        margin-right: auto;
    }
    
     
     
    
    // Fonts ************************************

    body .fw-3, .st-3, .st-4 { font-weight: 300;}
    body .fw-4 { font-weight: 400;}
    body .fw-6, .h4, .h5 { font-weight: 600;}
    body .fw-7 { font-weight: 700;}
    body .fw-8, strong, .h1, .h2, .h3 { font-weight: 800;}
    body .fw-9 { font-weight: 900; } 
    
    h1,h2,h3,h4,h5,h6 {
        margin: 0;
    }
    
    // Heading
    .h1 { font-size: 5.8rem; line-height: 1;}
    .h2 { 
        font-size: 4.8rem;
        @media (max-width: ${maxCol.md}) {
            font-size: 3.2rem;
        }
    }
    .h3 { 
        font-size: 3.2rem;
        @media (max-width: ${maxCol.md}) {
            font-size: 2.4rem;
        }
    }
    .h4 {
        font-size: 2.8rem;
        @media (max-width: ${maxCol.md}) {
            font-size: 2.2rem;
        }
    } 
    .h5 { 
        font-size: 2.4rem;
        @media (max-width: ${maxCol.md}) {
            font-size: 1.8rem;
        }
    }
    
    .h2,.h3,.h4,.h5  {
        line-height: 1.25;
    }
    
    // Subtitle
    .st1 { 
        font-size: 2rem; line-height: 1.1;
        @media (max-width: ${maxCol.md}) {
            font-size: 1.6rem;
        }
    } 
    .st2 { font-size: 1.8rem; } 
    .st3 { font-size: 1.6rem; }  // Body Text 
    .st4 { 
        font-size: 1.4rem;
        @media (max-width: ${maxCol.md}) {
            font-size: 1.2rem;
        }
    } 
    .st5 { font-size: 1.2rem; }  // Note
    
    .st2,.st3,.st4,.st5  { 
        line-height: 1.25;
    }
    
    // color ************************************
    
    .box {
        width: 20rem;
        height: 7.5rem;
        color: #fff;
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bgc1, .bgc-dark { background-color: var(--dark); }
    .bgc2, .bgc-gray { background-color: var(--gray); }
    .bgc3, .bgc-lgray { background-color: var(--lgray); }
    .bgc4, .bgc-slgray { background-color: var(--slgray); }
    .bgc5, .bgc-paper { background-color: var(--paper); }
    .bgc6, .bgc-red { background-color: var(--red); }
    .bgc7, .bgc-green { background-color: var(--green); }
    .bgc8, .bgc-blue { background-color: var(--blue); }

    .bgc8:hover { background-color: var(--gray); color: #fff } 
    
    .bgc9, .bgc-yellow { background-color: var(--yellow); }
      
    body .tc1,body  .tc-dark  { color: var(--dark); }
    body .tc2,body  .tc-gray { color: var(--gray); }
    body .tc3,body  .tc-lgray  { color: var(--lgray); }
    body .tc4,body  .tc-slgray  { color: var(--slgray); }
    body .tc5,body  .tc-paper { color: var(--paper); }
    // CMS обирає .tc5 (var(--paper)) для тексту банера заради контрасту з
    // темним фоновим зображенням/градієнтом — це фіксований "світлий текст
    // на картинці", а не "чорнило" сторінки, тому в темній темі не повинен
    // інвертуватись разом з --paper. Живе тут (не в BlockBannerSlider.js),
    // бо тільки createGlobalStyle не скоупить [data-theme="dark"] під
    // якийсь styled-component клас.
    [data-theme="dark"] .BlockBannerSlider .tc5 {
        color: var(--chrome-light);
    }
    body .tc6,body  .tc-red { color: var(--red); }
    body .tc7,body  .tc-green  { color: var(--green); }
    body .tc8,body  .tc-blue  { color: var(--blue); }
    body .tc9,body  .tc-yellow  { color: var(--yellow); }
    
    // Badges ************************************
    
    .bds {
        font-size: 1.2rem;
        line-height: 1; 
        text-align: center;
        text-transform: uppercase; 
        padding: 0.8rem 2.45rem; 
        border-radius: 5.5rem;
        display: inline-flex;
        color: var(--paper);
        z-index: 2;
        &.min {
            padding: 0.5rem 1.25rem;
        }
        @media (max-width: ${maxCol.md}) {
            padding: 0.5rem 1.25rem;
        }
    }
    // Бейджі товару (напр. "Передзамовлення") мають кольоровий фон
    // (bgc7/--green тощо), що НЕ інвертується з темою — тому текстовий
    // колір з CMS (tc1 = var(--dark)) теж має лишатись фіксованим, а не
    // світлішати в темній темі до нечитабельного контрасту з кольоровим
    // фоном. Той самий принцип, що й для .body.colorRevers/банера.
    [data-theme="dark"] .bds.tc1 {
        color: var(--chrome-dark);
    }

    // Icons ************************************

    // Майже всі спрайти-іконки (Icons24px-N.svg) — статичні SVG-файли із
    // захардкодженим кольором #363738 (як і Logo.svg), тому самі по собі не
    // реагують на тему і в темному режимі зливаються з фоном ("губляться").
    // Той самий трюк (filter: brightness(0) invert(1)), що вже
    // використовується для .iconWhite і колись для .body.colorRevers —
    // застосовуємо до всіх номерів, окрім:
    // - 15, 18 — не використовуються живим кодом (лише вимкнена
    //   src/pages/type.js__);
    // - тих, де вже є .iconWhite в JSX (соцмережі футера, деякі стрілки) —
    //   виключаємо через :not(.iconWhite), інакше подвійна інверсія
    //   поверне їх назад у темний колір;
    // - іконки з власним кольором (блакитне серце вішлиста, exit-blue,
    //   YouTube/email у футері) — це окремі, не пронумеровані класи, тому
    //   під цей перелік номерів не потрапляють.
    ${[1,2,3,4,5,6,7,8,9,10,11,12,13,14,16,17,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38]
        .map(n => `[data-theme="dark"] .iconBG${n}:not(.iconWhite):before`)
        .join(',\n    ')} {
        filter: brightness(0) invert(1);
    }

    .icon24:before {
        width: 2.4rem;
        height: 2.4rem;
        display: inline-flex;
    }
    .icon18:before {
        width: 1.8rem;
        height: 1.8rem;
        display: inline-flex;
    }
    .iconBG {
        display: flex;
        align-items: center;
        &.iconWhite {
            filter: brightness(0) invert(1);
        }
    }
    .iconBG:before {
        display: inline-flex;
        content:'';
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        //margin-right: 2rem;
        z-index: 2;
    }
    
     
    
    // Buttons ************************************
    button {
        box-shadow: none !important; 
        //border: none;
    } 
    .btn {
        //margin: 0.4rem;
        box-shadow: none !important;
        align-items: center;
        justify-content: center;
        display: inline-flex;
        cursor: pointer;
        text-transform: uppercase;
        font-weight: 900;
        line-height: 1;
        position: relative;
        overflow: hidden;
        text-decoration: none;
        span {
            z-index: 2;
        }
        &:after {
            content: '';
            position: absolute;
            margin: auto;
            z-index: 1;
            display: block;
            top: -200%;
        }
        &.hideHover:after {
            display: none; 
        }
        
        
        
        &.btn1 {
            border: 0.2rem solid var(--divider);
            padding: 1.4rem 7rem;
            background-color: var(--paper);
            font-size: 1.6rem;
            color: var(--dark);
            &.min {
                padding-left: 1.6rem;
                padding-right: 1.6rem;
            }
            &:after {
                left: 0;
                right: 0;
                bottom: 0;
                width: calc(100% - 0.4rem);
                height: calc(100% - 0.4rem);
                background-color: var(--blue);
                border: 0.2rem solid rgba(0,0,0,0);
                opacity: 1;
            }
            &:hover, &.pressed {
                &:after {
                    top: 0;
                }
            }
            &.select, &[aria-current="page"] {
                &:after {
                    top: 0;
                    background: none;
                    border: 0.2rem solid var(--blue);
                }
            }
            &.selectBlack {
                justify-content: flex-start;
                padding-right: 0;
                &.select {
                    span {
                        color: var(--chrome-light);
                    }
                    &:after {
                        border: none;
                        background-color: var(--chrome-dark);
                    }
                }
            }
            
            &.disable, &.swiper-button-disabled { 
                border-color: var(--lgray);
                color: var(--lgray);
                cursor: default;
                &:after {
                    opacity: 0;
                }
            }
        } 
        &.btn2 {
            //border: 2px solid var(--gray);
            border: none;
            padding: 1.6rem 7.2rem;
            background-color: var(--chrome-dark);
            color: var(--chrome-light);
            font-size: 1.6rem;
            &:after {
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255,255,255,0.2);
            } 
            &:hover, &.pressed {
                &:after {
                    top: 0;
                }
            }
            &.select, &[aria-current="page"] {
                &:after {
                    left: 0;
                    top: 0;
                    width: calc(100% - 0.8rem);
                    height: calc(100% - 0.8rem);
                    background: none;
                    border: 0.2rem solid var(--blue);
                }
            }
            &.disable {
                border-color: var(--slgray); 
                background-color: var(--slgray);
                color: var(--lgray);
                cursor: default; 
                &:after {
                    display: none;
                }
            }
        }
        &.btn3 {
            //border: 2px solid var(--gray);
            border: none;
            padding: 1.6rem 7.2rem;
            background-color: var(--blue);
            color: var(--paper);
            font-size: 1.6rem;
            &:after {
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255,255,255,0.2);
            }
            &:hover, &.pressed {
                &:after {
                    top: 0;
                }
            }
            &.select, &[aria-current="page"] {
                &:after {
                    left: 0;
                    top: 0;
                    width: calc(100% - 0.8rem);
                    height: calc(100% - 0.8rem);
                    background: none;
                    border: 0.2rem solid var(--paper);
                }
            }
        }
        &.btn4 { 
            background-color: var(--slgray);
            border-radius: 3.2rem;
            display: inline-flex;
            align-items: center;
            font-weight: 400;
            text-transform: none;
            padding: 0.85rem 2.4rem 0.85rem 2.4rem;
            .iconBG {
                margin-left: 0.8rem;
            }
            &:hover, &[aria-current="page"] {
                background-color: var(--blue);
                color: var(--paper);
                .iconBG:before {
                    filter: brightness(0) invert(1);
                }
            }
        }
    
        &.btn5 {
            display: inline-flex;
            align-items: center;
            text-transform: none;
            //padding: 1.2rem 2.4rem 1.2rem 2.4rem;
            font-weight: 400;
            .iconBG {
                margin-left: 1.2rem;
            }
            &:hover { 
                color: var(--blue);
            }
        }
        &.btn6 {
            //border: 2px solid var(--gray);
            border: none;
            padding: 1.6rem 7.2rem;
            background-color: var(--chrome-dark);
            color: var(--chrome-light);
            font-size: 1.6rem;
            &:after {
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(255,255,255,0.2);
            }
            &:hover, &.pressed {
                &:after {
                    top: 0;
                }
            }
            &.select, &[aria-current="page"] {
                &:after {
                    left: 0;
                    top: 0;
                    width: calc(100% - 0.8rem);
                    height: calc(100% - 0.8rem);
                    background: none;
                    border: 0.2rem solid var(--blue);
                }
            }
            &.disable {
                border-color: var(--slgray);
                background-color: var(--slgray);
                color: var(--lgray);
                cursor: default;
                &:after {
                    display: none;
                }
            }
        }
    
    
        &.btnIcon {
            width: 5.6rem;
            height: 5.6rem;
            padding: 0;
            .iconBG {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 2;
            }
            &.disable, &.swiper-button-disabled {
                .iconBG {
                    opacity: 0.6;
                }
            }
        }
        
        &.btnIconSquare {
            .iconBG {
                border-radius: 50%;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                width: 4.6rem;
                height: 4.6rem;
                opacity: 1;
            }
            &:hover, &.pressed {
                .iconBG {
                    background-color: var(--blue);
                    &:before {
                        filter: brightness(0) invert(1);
                    }
                }
                
            }
        }
        &.borderNone {
            border: none;
        }
        &.bgNone {
           background: none;
        }
        
        &.cursorNone {
            cursor: default;
        }

    }


    // social login  ************************************

    .social-login {
        margin-top: 2rem;
        .social-login__divider {
            display: flex;
            align-items: center;
            text-align: center;
            margin: 2rem 0;
            color: var(--gray);
            font-size: 1.4rem;
            text-transform: lowercase;
            &:before, &:after {
                content: '';
                flex: 1;
                height: 0.1rem;
                background-color: var(--slgray);
            }
            span {
                padding: 0 1.2rem;
            }
        }
        .social-login__btn {
            width: 100%;
            gap: 1rem;
            svg {
                z-index: 2;
                flex-shrink: 0;
            }
            &:disabled {
                cursor: default;
                opacity: 0.6;
            }
        }
        .social-login__btn + .social-login__btn {
            margin-top: 1.2rem;
        }
    }


    // form input  ************************************
    
    
    
    
    .wrap-form {
        .formTitle {
            &.style-1 {
                color: var(--blue);
                margin-bottom: 2rem;
                line-height: 1.25;
            }
        }
    }
    .wrap-input {
        margin-bottom: 1.6rem;
        label {
            font-size: 1.4rem;
            font-weight: 300;
            line-height: 1;
            text-align: left;
            display: block;
            color: var(--lgray);
            margin-bottom: 1.4rem;
        }

        
        
        input, textarea {
            display: block;
            font-size: 1.6rem;
            line-height: 1.25;
            background-color: var(--slgray);
            color: var(--gray);
            border: 0.2rem solid var(--slgray);
            width: 100%;
            height: 5.6rem;
            padding: 0 2.4rem; 
            &::placeholder {
                color: var(--lgray); 
            }
            &:active, &:focus {
                border: 0.2rem solid var(--blue);
            }
        }
        label {
            &.WrapCheckbox {
                color: var(--gray);
                display: flex;
                align-items: center;
                input[type="checkbox"] {
                    display: none;
                    & + span {
                        //border: 2px solid var(--gray);
                        border: 0.2rem solid var(--lgray);
                        width: 4.8rem;
                        height: 2.4rem;
                        position: relative;
                        display: block;
                        margin-right: 1.2rem;
                        border-radius: 2rem;
                        cursor: pointer;
                        transition: 500ms all;
                        &:before {
                            content: '';
                            width: 2.4rem;
                            height: 2.4rem;
                            display: block;
                            position: absolute;
                            top: -0.2rem;
                            left: -0.2rem;
                            border-radius: 50%;
                            background-color: var(--paper);
                            border: 0.2rem solid var(--divider);
                            transition: 500ms all;
                        }
                    }
                    &:checked { 
                      & + span {
                          &:before {
                              left: calc(100% - 2.4rem + 0.2rem );
                              background-color: var(--blue);
                              border-color: var(--blue);
                          }
                      }  
                    }
                }
            }
        }  
        
        
        &.WrapRadio {
            input[type="radio"] {
                display: none;
                & + span {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-right: 1.2rem;
                    border-radius: 2rem;
                    cursor: pointer;
                    transition: 500ms all;
                    padding-left: 3.2rem;
                    height: 1.8rem;
                    &:before, &:after {
                        content: '';
                        display: block;
                        position: absolute;
                        border-radius: 50%;
                        transition: 500ms all;
                    }
                    &:before {
                        width: 1.8rem;
                        height: 1.8rem;
                        left: 0;
                        background-color: var(--paper);
                        border: 0.2rem solid var(--divider);
                    }
                    &:after {
                        width: 0.8rem;
                        height: 0.8rem;
                        background-color: var(--blue);
                        opacity: 0;
                        left: 0.5rem;
                        top: 0.5rem;
                    }
                }
                &:checked {
                    & + span {
                        &:after {
                            opacity: 1;
                        }
                    }
                }
            }
        }
        

        input[type="radio"] {
            
        }
        
        &.error {
            label {
                color: var(--red);
            }
            input, textarea {
                border-color: var(--red);   
            }
        }
    
        textarea {
            height: 11.2rem;
            padding: 2.4rem;
        }
        
        &.searchBox {
            position: relative;
            border: 0.2rem solid var(--lgray);
            display: flex;
            align-items: center;
            .btn {
                margin: 0;
                min-width: 5.8rem;
            }
            .iconBG:before {
                filter: brightness(0) invert(1);
            }
    
            .btn {
                border-left: 0.2rem solid var(--lgray);
            }
            
            &.black {
                input {
                    background-color: var(--chrome-dark);
                    border-color: var(--chrome-dark);
                    color: var(--chrome-light);
                }
                border: 0.2rem solid var(--chrome-dark);
                .btn {
                    border-left: 0.2rem solid var(--chrome-dark);
                    background-color: var(--chrome-dark);
                }
            }
        }
    }
    
    // link  ************************************
    
    
    a {
        color: inherit;
        &:hover {
            color: var(--blue);
        }
    }
    
    .link {
        cursor: pointer;
        //text-transform: none;
        text-decoration: none;
        &.link-1, &.link-2 {
            width: fit-content;
            position: relative;
            overflow: hidden;
            display: inline-flex;
            padding-bottom: 1rem;
            &:after, &:before {
                content: "";
                display: block;
                position: absolute;
                height: 0.2rem;
                background-color: var(--divider);
                bottom: 0rem;
            }
            &:before {
                transform: translate3d(-102%, 0, 0);
                transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1);
            }
            &:after {
                transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1) 200ms;
            }
        
            &:hover {
                &:before {
                    transform: translate3d(0%, 0, 0);
                    transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1) 200ms;
                }
                &:after {
                    transform: translate3d(calc(101% + 2rem), 0, 0);
                    transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1);
                }
            }
        }
        
        &.link-1 {
            &:after, &:before {
                width: 50%;
            }
            &:after {
                display: none;
            }
        }
        &.link-2 {
            &:after, &:before {
                width: 100%;
            }
            &:before {
                display: none;
            }
            &:hover { 
                &:after {
                    transform: translate3d(calc(30%), 0, 0);
                    transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1);
                }
            }
        }
        &.link-3 {
            color: inherit;
            &:hover {
                color: var(--blue);
            }
        }
    }


    
    
    
    // css  ************************************


    .WrapPostcode input::-webkit-outer-spin-button,
    .WrapPostcode input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    .WrapPostcode input[type=number] {
        -moz-appearance: textfield;
    }
 
    //ValidCheckout
    //handleCheckboxChangePerson
     
    .wrapCartRight {
        .infoMassage {
            //max-width: 40rem;
        }
    }
     
    .wrapSum {
        @media (min-width: ${minCol.lg}) {
            .infoMassage {
                position: absolute; 
                top: calc(100% + 1rem);
                left: 0;
            }
        }
    }

    .infoMassage {
        padding: 1rem;
        padding: 1.8rem 3.8rem;
        color: var(--chrome-light);
        margin-top: 1rem;
        margin-bottom: 1rem;
        &.error {
            background-color: var(--red);
        } 

        &.process {
            background-color: var(--yellow);
            color: var(--grey);
        }
        
        p {
            margin-bottom: 1rem;
            &:last-child {
                margin-bottom: 0;
            }
        }
        &.done {
            background-color: var(--green);
        }
    }
    
    .pointer {
        cursor: pointer;
    } 
  
    .template-Constructor, .template-blog, 
    .template-categoriesUniverse, .template-categoriesProduct, .template-categoriesGenre,
    .template-tagsProduct, .template-person, .template-persons, .template-Persons, .template-product, 
    .template-Wishlist, .template-Account, .template-Default, .template-promotions, .template-post, .template-OrderReceived {
        .main {
            &:before {  
                content: ''; 
                display: block;
                position: absolute;
                left: -2000px;
                right: -2000px;
                background-color: var(--divider);
                height: 0.2rem;
                top: auto;
                bottom: 0;
                @media (max-width: ${maxCol.sm} ) { 
                    bottom: 1px;
                }
                z-index: 15;
            }
        }
    }

    .template-post  .wrap-post {
        position: relative;
        &:before {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: 0;
            z-index: 15; 
        }
    }
    
    .template-Wishlist { 
        .wrapWishListShare {
            padding-bottom: 0.2rem;
        }
    }

    .template-product .main:before {
        bottom: 0.2rem;
    }

    .jsAccordion {
         
    }

    .template-person {
        .WrapAccordion {
            margin-top: -0.2rem;
            &.close:last-child {
                margin-top: -0.2rem; 
            }
        }
        .jsAccordion {
            &:last-child.loadBtn_false {
                margin-bottom: -0.2rem;
            }
        }
        .WrapFilter {
            &:before {
                content: '';
                display: block;
                position: absolute;
                left: -2000px;
                right: -2000px;
                background-color: var(--divider);
                height: 0.2rem;
                top: 0;
                bottom: auto;
                z-index: 15;
            }
        } 
    }
    
    .template-categoriesProduct, .template-categoriesUniverse, .template-categoriesSeries, .template-categoriesGenre {
        .pagination {
            position: relative;
            &:after {
                content: '';
                display: block;
                position: absolute;
                left: -2000px; 
                right: -2000px;
                background-color: var(--divider);
                height: 0.2rem;
                top: -0.2rem;
            }
        }
        .wrap-product {
            //margin-bottom: 0;
            .col:after {
                left: -2000px;
                right: -2000px;
            }
            + .h2 {
                margin-top: 6rem;
            }
        }

        [class*="numPages-"]:not([class="numPages-1"]) .WrapFilters {
            //display: none !important; 
        }  
         
        .row { 
            &.wrap-product.openFilter {
                @media (min-width: ${minCol.lg}) {
                    & > *:nth-child(3n + 1)  {
                        //margin-left: calc(25% - 1px);
                        margin-left: 25%;
                        .product-item { 
                            //border-left: 2px solid var(--dark);
                        }
                    } 
                }
                 
                @media (max-width: ${maxCol.lg}) {
                    & > * {
                        margin-left: 0;
                    }
                    & > *:nth-child(2n + 2)  { 
                        margin-left: calc(33.33% - 0.1rem);  
                        .product-item {
                            //border-left: 2px solid var(--dark);
                        }
                    }
                    .line-decore-1 { 
                        left: calc(33.3333333333% * 2);
                    }
                }

                @media (max-width: ${maxCol.md}) {
                    & > * {
                        margin-left: 0 !important; 
                    }
                    .line-decore-1 {
                        left: 50% !important;
                    }
                    & > *:nth-child(2n + 1)  {
                        //margin-left: calc(50% - 1px);
                        margin-left: 0;
                        .product-item {
                            //border-left: 2px solid var(--dark);
                        }
                    }
                }
            }
        }
    }


    .no-select {
        user-select: none; /* Забороняє виділення тексту */
        -webkit-user-select: none; /* Для браузерів на базі Webkit */
        -moz-user-select: none; /* Для Firefox */
        -ms-user-select: none; /* Для старих версій Internet Explorer */
    }
    
    .template-product footer {
        padding-bottom: 7rem;
    }
 
    .template-person .main section {
        padding-bottom: 0.2rem;
    }

    .wrapWishListShare {
        height: 6.6rem; 
        //padding-bottom: 2px;
        .a { 
            height: 100%;
        }
        span:before {
            margin-left: 0.8rem; 
        }
        @media (max-width: ${maxCol.sm}) {
            height: 5.6rem; 
        }
        .iconBG:before {
            transform: rotate(90deg);
        }
    }

    .wrapTitleBlock.open .wrapHeaderIcon {
        .iconBG:before {
            transform: rotate(180deg);
        }
    }
    
    blockquote {
        border-left: 0.2rem solid var(--blue);
        margin: 1rem;
        padding: 1rem 0 1rem 2.4rem;
        p {
            &:last-child {
                margin: 0;
            }
        }
    }

    .WishlistBtn {
        border: none;
        background: rgba(0,0,0,0);
    }
        
    html {
        --fancybox-scrollbar-compensate: 0 !important;;
    }
     
    .anim, a, .a, .btn, .btn:before, .btn:after, .iconBG, .iconBG:before, .link, input, textarea, .swiper-pagination-bullet {
        transition: all 0.5s ease;
        //transition: 1000ms transform cubic-bezier(0.23, 1, 0.32, 1) 200ms;
        transition: 500ms all; 
    }
    
    p {
        margin: 0 0 2rem;
    }
    
    .pb-0 {
        padding-bottom: 0;
    }
    
    .mt-auto {
        margin-top: auto;
    }
    
    .p-0 {
        padding: 0 !important;
    }

    .mt-8 { margin-top: 0.8rem;}
    .mt-16 { margin-top: 1.6rem;}
     
    .mb-0 { margin-bottom: 0 !important; } 

    .mb-8 { margin-bottom: 0.8rem;}

    .mb-14 { margin-bottom: 1.4rem;}
    .mb-16 { 
        margin-bottom: 1.6rem;
        @media (max-width: ${maxCol.md}) {
            margin-bottom: 1.2rem;
        }
        
    }
    .mb-20 {
        margin-bottom: 2rem;
        @media (max-width: ${maxCol.md}) {
            margin-bottom: 1.2rem;
        }
    }
    .mb-24 { 
        margin-bottom: 2.4rem;
        @media (max-width: ${maxCol.md}) {
            margin-bottom: 1.8rem;
        }
    }
    .mb-32 { margin-bottom: 3.2rem;}
    
    
    
    
    .grey {
        //filter: grayscale(100%);
    }
    .grey_off {
        filter: none;
    }
    .pos {
        position: relative;
    }
    .z-in-1 {
        z-index: 1;
    }
    .z-in-2 {
        z-index: 2;
    }
    .h100 {
        height: 100%;
    }
    .h50 {
        height: 50%;
    }
    .mh100 {
        min-height: 100%;
    }
    .mh50 {
        min-height: 50%;
    }
    .w100 {
        width: 100%;
    }
    .ul-clear {
        margin: 0;
        padding: 0;fbutton
    }
    .ul-clear li::marker {
        font-size: 0;
    }
    .p-0 {
        padding:0;
    }
    .pr-0 { 
        padding-right: 0 !important;
    }
    .pl-0 {
        padding-left: 0 !important;
    } 

    .pr-3 {
        padding-right: 3rem !important;
    }
    .pl-3 {
        padding-left: 3rem !important;
    }
    
    .pt-0 {
        padding-top: 0 !important;
    }
    .pb-0 {
        padding-bottom: 0 !important;
    }
    
    .m-0 {
        margin:0 !important;
    }
    
    .ml-auto {
        margin-left: auto;
    }
    
    .mr-auto {
        margin-right: auto;
    }
    
    .text-center {
        text-align: center;
    }
    .text-right {
        text-align: right;
    }
    .body {
        overflow: hidden;
    }
    .ttu {
        text-transform: uppercase;
    }
    .rotate {
        transform: rotate(180deg)
    }
     
    // border-line-block  ************************************
    
    .row-0 {
        --bs-gutter-x: 0 !important;
    }
    .row-section {
        & > * {
            border-right: 0.2rem solid var(--divider);
            &:last-child {
                border-right: none;
            }
        }
        &.color-white {
            & > * {
                border-right: 0.2rem solid var(--paper);
            }
        }
    }
    
    // wrapMain
    
    .wrapMain {
        min-height: calc(50vh - 1.8rem - 1.8rem - 8rem); 
    }
    
    .border-ver {
        position: relative;
        padding-right: 0.2rem;
        padding-left: 0.2rem;
        &:before, &:after {
            content: '';
            display: block;
            position: absolute;
            top: -1000px;
            bottom: 0px;
            left: 0;
            background-color: var(--divider);
            width: 0.2rem;
            z-index: 1;
        }
        &:after {
            left: auto; 
            right: 0;
        }
        &.color-white {
            &:before, &:after {
                background-color: var(--paper);
            }
        }
    }
     
    .border-hor {
        position: relative;
        padding-top: 0.2rem;
        padding-bottom: 0.2rem;
        &:before, &:after {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: 0;
        }
        &:after {
             bottom: 0;
            top: auto;
        }
        &.color-white {
            &:before, &:after {
                background-color: var(--paper);
            }
        }
    }
    
    .WrapAutor {
        .wrap-product {
            &:before {
                content: '';
                display: block;
                position: absolute;
                left: -2000px;
                right: -2000px;
                background-color: var(--divider);
                height: 0.2rem;
                top: 0;
                bottom: auto;
            }
        }
    }
    
    .border-hor-bottom {
        padding-bottom: 0.2rem;
    } 
    .border-hor-top {
        padding-top: 0.2rem; 
    }
    
    .border-hor-bottom, .border-hor-top {
        position: relative;
        &:after {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: 0;
        }
        &:after {
            bottom: 0;
            top: auto;
        }
        &.color-white {
            &:after {
                background-color: var(--paper);
            }
        }
    }

    .border-hor-top {
        &:after {
            bottom: auto;
            top: 0;
        }
    }

    // Футер тепер теж уніфіковано на --divider (користувач попросив зробити
    // всі лінії однаково приглушеними, включно з нижньою панеллю) — окремого
    // override більше не потрібно, .border-hor-top/.border-hor-bottom вище
    // застосовується без винятків.


    
    // menu ************************************
     
    .wrapMenu {
        [aria-current="page"] {
            color: var(--blue);
        }
        ul {
            margin: 0;
            padding: 0;
        }
        a {
            text-decoration: none;
        }
        ::marker {
            font-size: 0;
        }
        &.style-1 {
            height: 100%;
            padding: 0 4.8rem;
            .has-child {
                padding-right: 5.2rem; 
                & > a {
                    position: relative;
                    &:before {
                        content: '';
                        top: -0.2rem; 
                        bottom: 0;
                        right: -1.6rem;
                        z-index: 1;
                        width: 0.8rem;
                        height: 0.8rem;
                        display: block;
                        border-right: 0.18rem solid var(--divider);
                        border-top: 0.18rem solid var(--divider); 
                        position: absolute;
                        margin: auto;
                        transform: rotate(135deg);
                        transition: 500ms all;
                    }
                }
                &:hover a {
                    &:before { 
                        top: 0.6rem;
                        transform: rotate(-45deg);
                    }
                }
            }
            .subMenu {
                left: -0.5rem;
                top: calc(100% + 1rem);
                position: absolute;
                //background-color: var(--paper);
                z-index: 1;
                display: inline-block;
                visibility: hidden;
                opacity: 0;
                transition: 500ms all;
                padding: 1.8rem;
                &:before, &:after {
                    background-color: var(--paper);
                    z-index: 0;
                    position: absolute;
                    top: -0.5rem;
                    bottom: -0.5rem;
                    left: -0.5rem;
                    right: -0.5rem; 
                    content: '';
                    display: block; 
                }
                &:before {
                    top: 0.5rem;
                    bottom: 0.5rem; 
                    left: 0.5rem;
                    right: 0.5rem;
                    border: 0.2rem solid var(--divider);
                    z-index: 1;
                }
                a {
                    white-space: pre;
                }
                li {
                    margin-bottom: 1rem;
                    margin-top: 1rem;
                    padding-right: 0;
                    z-index: 2;
                    &:first-child {
                        margin-top: 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            li {
                padding-right: 4.2rem;
                position: relative;
                height: 100%;
                display: flex;
                align-items: center;
                &:hover {
                    .subMenu {
                        visibility: visible;
                        opacity: 1;
                    } 
                }
                &:last-child { 
                    padding-right: 0;
                }
            }
            @media (max-width:${maxCol.xl}) {
                padding: 0 2.4rem; 
                li {
                    padding-right: 2.1rem;
                }
            }
        }
        &.style-2 {
            button {
                width: 100%;
                background: none;
                border: none;
                color: var(--chrome-light);
                text-align: left;
                font-size: 1.6rem;
                padding-left: 0;
            }
            li {
                margin-bottom: 3.2rem;
            }
            .ul-sub {
                position: absolute;
                top: 2rem;
                width: calc(100% - 4rem);
                left: 2rem;
                bottom: 2rem;
                z-index: 1;
                padding-top: 5rem;
                background-color: var(--chrome-dark);
                transition: 500ms all;
                &.open {
                    left: 2rem;
                    opacity: 1;
                    visibility: visible;
                }
                &.close {
                    left: 2rem;
                    opacity: 0;
                    visibility: hidden;
                }
            }
            .a {
                display: block;
                position: relative;
                min-height: 2.4rem;
                cursor: pointer;
                font-size: 1.6rem;
            }
    
            .return:before, .sub > .a:before {
                background-image: url(${Icons24_31});
                content: '';
                display: block;
                width: 2.4rem;
                height: 2.4rem;
                position: absolute;
                top: 0;
                bottom: 0;
            }
            .sub > .a {
                &:before {
                    filter: brightness(0) invert(1);
                    right: 0;
                }
            }
    
            .return {
                width: 100%;
                border: none;
                background: none;
                position: relative;
                min-height: 2.4rem;
                display: flex;
                align-items: center;
                padding-left: 5.6rem;
                color: var(--lgray);
                cursor: pointer;
                margin-bottom: 5.4rem;
                &:before {
                    transform: rotate(180deg);
                    left: 0;
                    right: auto;
                }
            }
        }
    } 
    
    .iconBG32:before  { background-image: url(${Icons24_32}); }
    .iconBG31:before  { background-image: url(${Icons24_31}); }
    
    .wrapTitleBlock {
        .wrapHeaderIcon {
            @media (min-width: ${minCol.md}) {
                min-height: 6.6rem;
                .btn {
                    min-height: 6.6rem;
                    min-width: 6.6rem;
                }
            }
        }
        .BlockTitle {
            font-size: 3rem; 
            line-height: 1.25;
            padding-left: 4.2rem;
            padding-right: 4.2rem;
            text-decoration: none;
            @media (max-width: ${maxCol.sm}) {
                padding-right: 0;
                padding-left: 2.4rem;
                font-size: 2.4rem;
            }
            &.min {
                padding-left: 2.4rem;
                .iconBG {
                    margin-right: 1.6rem;
                }
            }
        }
        .wrapHeaderIcon {
            display: flex;
            align-items: center;
            justify-content: center; 
        }
        .more {
            padding-right: 2.4rem;
            .wrapStar {
                margin-bottom: 0;
            }
        }
    }
    .body {
        //padding-top: 1.8rem;
    } 
    
    .WrapHeaderScroll {
        margin-top: 1.8rem;
        position: relative;
        height: 6.8rem;
        @media (max-width: ${maxCol.xl}) {
            height: 6rem;
        }
        //.header .row.border-ver {
        //    padding-left: 0;
        //    padding-right: 0;
        //}
    }
     
    .popInform {
        [go]:not(.active) {
            display: none;
        }  
        .iconBG {
            margin-left: 2rem;
            cursor: pointer;
            filter: brightness(0) invert(0);
        }
        &[type="info"] {
            .wrap {
                background-color: var(--blue);
                .title {
                    color: var(--dark);
                }
                .text {
                    color: var(--gray);
                }
            }
            
        }
 
        &[type="infoUP"] {
            .wrap {
                background-color: var(--green); 
                .title {
                    color: var(--dark);
                }
                .text {
                    color: var(--gray);
                } 
            }
        } 
        &[type="warning"] { 
            .wrap {
                background-color: var(--yellow);
                .title {
                    color: var(--dark);
                }
                .text {
                    color: var(--gray);
                }
            }
        }
        
        .wrap {
            padding: 1.2rem;
            @media (min-width: ${minCol.md}) {
                padding: 2.4rem 3rem;
                .title {
                    font-size: 2rem;
                }
                .text {
                    font-size: 1.8rem;
                }
            }
            @media (max-width: ${maxCol.sm}) {
                padding: 2.4rem;
                position: relative;
                .iconBG {
                    position: absolute;
                    top: 1.2rem;
                    right: 1.2rem;
                    z-index: 2;
                }
            }
        }
        .row { 
            align-items: center;
        } 
        .title {
            
            
        }
        .text {
            p {
                line-height: 1;
                margin-bottom: 0.4rem;
                margin-top: 0.4rem;
            }
            @media (max-width: ${maxCol.lg}) {
                margin-top: 1.2rem;
            }
            @media (max-width: ${maxCol.sm}) {
                margin-bottom: 2rem;
                margin-top: 2rem;
            }
        }
        position: fixed;
        left: 0;
        right: 0;
        z-index: 200;
        bottom: -30rem;
        &.active {
            bottom: 0;
        }
    }

    .iconBG20:before  { background-image: url(${Icons24_20}); }
    
    
    .cart-empty {
        margin-top: 3rem;
        margin-bottom: 3rem;
    }
    
    
    .hide {
        display: none !important;
    }
    
    
    .wrap-checkbox.error {
        span {
            color: var(--red);
        }
    }
    
    [for="WrapRadio"] {
        display: block;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;  
    } 
    body .blockGetProduct .wrap-product, .wrap-product.is_slider {
        position: relative;
        &:before {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: 0;
            width: auto;
        }
    }
    // Футер лишаємо як є (та сама позиція/яскравість, що й раніше) —
    // окреме правило, не чіпає --divider вище.
    body .footer-2 .wrapTitleBlock {
        position: relative;
        &:before {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: 0;
            width: auto;
        }
    }
    
    .space {
        height: 6.6rem;
        @media (max-width: ${maxCol.sm}) {
            height: 5.6rem;
        }
    }

    .hideSliderElement {
        .swiper-pagination-bullet {
            opacity: 0;
        }
    }
    
    .blockGetProduct.slider {
        position: relative;
        &:after {
            content: '';
            display: block;
            position: absolute;
            left: -2000px;
            right: -2000px;
            background-color: var(--divider);
            height: 0.2rem;
            top: auto;
            bottom: 6.4rem;
            width: auto;
            @media (max-width: ${maxCol.md}) {
                bottom: 5.2rem;
            }
        }
    }

    .blockGetProduct.list + div {
        margin-top: -0.2rem;
    }
     
    body .footer-2 .wrapTitleBlock:before {  
        top: auto;
        bottom: 0 !important; 
    } 
    
    //.swiper-backface-hidden .swiper-pagination span {
    //    display: none;
    //}

    .swiper-wrapper {
        height: auto; 
    }

    .swiper {  
        //overflow: initial !important;
        //.swiper-wrapper {
        //    &:before, &:after {
        //        content: '';
        //        display: block;
        //        background: var(--paper);
        //        top: 0;
        //        bottom: 0;
        //        position: absolute;
        //        max-width: 1440px;  
        //        margin: auto; 
        //        z-index: 10;
        //    }
        //}  
        //.swiper-slide {
        //    opacity: 0;
        //}
        //.swiper-slide-active, .swiper-slide-next {
        //    opacity: 1;
        //}
    }

    @media (max-width: ${maxCol.md}) {
        .wrapFilterBtn {
            div:nth-child(2) {
                margin-right: 0 !important;
                margin-left: auto !important;
            }
        }
    }


    .wrap-post .row > *:last-child .itemPost:after {
        background-color: var(--divider) !important;
    }
    
    @media (max-width: ${maxCol.sm}) {
        .wrap-post {
            .row {
                *:nth-child(2),
                *:nth-child(4),
                *:nth-child(5) {
                    .itemPost {
                        display: flex;
                        flex-direction: row-reverse;
                    }
                    .wrap-text { 
                        display: block;
                    }
                    .WrapImg {
                        //min-width: 10rem;
                        //max-width: 10rem;
                        //height: 6rem;
                        min-width: 14rem;
                        max-width: 14rem;
                        height: 10rem;
                        margin-left: 1.5rem;
                        img, [data-gatsby-image-wrapper] {
                            width: 100% !important;
                            height: 100% !important; 
                        }
                    }
                }
            }
        }
        
    }
    
    .WrapMobileBtn {
        border-left: 0.2rem solid var(--divider);
        border-right: 0.2rem solid var(--divider);
        a {
            background-color: rgba(0,0,0,0) !important;
            color: var(--chrome-light) !important;
            text-transform: none; 
            .iconBG {
                margin-left: 2rem;
                filter: brightness(0) invert(1);
            }
        }
    }

    .list-catalog {
        a {
            margin: 0;
            padding: 0;
            background: rgba(0,0,0,0);
            border: none;
            width: 100%;
            min-height: 8.2rem; 
            text-align: center;
            text-decoration: none;
        }
        & > *:nth-child(odd) {
            border-right: 0.2rem solid var(--divider);
        }
    }

    /* Стилі для кастомного прогрес-бару прокрутки */
    .scrollProgress {
        position: fixed;
        top: 0;
        left: 0;
        height: 0.4rem;
        background-color: var(--blue); /* бажаний колір */
        width: 0%;
        z-index: 100;  
    }

    /* Приховуємо нативний скролбар для браузерів WebKit */
    body {
        scrollbar-width: none; /* Firefox */
    }
    body::-webkit-scrollbar {
        display: none;
    }
    
    #gatsby-plugin-page-progress {
        z-index: 90;
    } 
    .WrapFilters .mobile {display: none}
    @media (max-width: ${maxCol.md}) {
        .ovhMobile {
            overflow: hidden;
        }
        .WrapFilters .mobile {
            display: block;
            
        }

    }
    
    .page-step {
        .WrapFilter {
            display: none;
        }
    }

    .WrapDesc { 
        .row {
            --bs-gutter-x: 1.7rem;
        }
        .text {
            margin-bottom: 2.4rem;
            @media (min-width: ${minCol.xl}) {
                max-width: 45.5rem;
            }
        }
        .desc {
            p {
                margin: 0 0 1.2rem;
            }
        }
        .wrapScroll {
            padding-right: 2.4rem;
            overflow: auto;
            max-height: 20rem;
            @media (max-width: ${maxCol.md}) {
                max-height: 30rem;
            }
            /* width */
            &::-webkit-scrollbar {
                width: 2px;
                height: 4px;
            }
            // #86644B 
            /* Track */
            &::-webkit-scrollbar-track {
                background-color: var(--gray);
            }

            /* Handle */
            &::-webkit-scrollbar-thumb {
                background: var(--paper);
            }
        }
        &.style-2 { 
            padding: 6.2rem;
            @media (max-width: ${maxCol.lg}) {
                padding-left: 2rem;
                padding-right: 2rem;
            }
            @media (max-width: ${maxCol.md}) {
                padding: 4rem 0rem;
            }

            .wrapScroll {
                padding-right: 2.4rem;
                overflow: auto;
                max-height: 20rem;
                @media (max-width: ${maxCol.md}) {
                    max-height: 30rem;
                }
                /* width */
                &::-webkit-scrollbar {
                    width: 4px;
                    height: 4px;
                }
                // #86644B 
                /* Track */
                &::-webkit-scrollbar-track {
                    //background-color: var(--gray);
                    background: rgba(54,55,56, 0.1); 
                } 

                /* Handle */
                &::-webkit-scrollbar-thumb { 
                    //background: var(--paper);
                    background: rgba(54,55,56, 0.4); 
                }
            }
        } 
    }
    .product-item {
        [data-gatsby-image-wrapper], .wrapImg {
            padding-bottom: 140%;
            width: 100% !important;
            height: auto !important;
            img {
                height: auto; 
                left: 0; 
                position: absolute;
                top: 0;
                width: 100%; 
                object-fit: cover;
            } 
        }
        .Slide img {
            height: auto;
            left: 0;
            position: absolute;
            top: 0;
            width: 100%;
            object-fit: cover;  
        }
    } 
    
    .wrap-product-block {
        .Slide {
            padding-bottom: 144%;
            position: relative; 
        }
        [data-gatsby-image-wrapper], .wrapImg {
            position: absolute !important;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            width: 100% !important;
            height: 100% !important;
            img {
                height: auto; 
                left: 0;
                position: absolute;
                top: 0;
                width: 100%;
                object-fit: cover;
            } 
        }
    }
`;

export default GlobalStyles;